<script lang="ts">
	import BackupSelect from "$lib/ui/home/groc/pdp/BackupSelect.svelte";
	import GrocPDP, { product$, setBackup, showDetail } from '$lib/ui/home/groc/pdp/Main.svelte';
	import Modal from "$lib/ui/shared/Modal.svelte";

	type Props = {
		close?: () => void | undefined;
	};

	let {
		close,
	}: Props = $props();

	let showBackupModal = $state(false);
</script>

<Modal child={showBackupModal} on:close={() => { close ? close() : showDetail(null); }} size={'large'}>
	<GrocPDP on:showBackupModal={() => showBackupModal = true} on:close={e => showDetail(null)} />

	<!-- BEGIN NESTED GROC BACKUP SELECT -->
	<Modal slot="modal" on:close={() => (showBackupModal = false)} size='large' id="backup">
		<span slot="header" class="headline-m bold">Select Backup</span>
		{#if $product$}
			<BackupSelect product={$product$} on:backup={(e) => setBackup(e.detail)} />
		{/if}
	</Modal>
	<!-- END NESTED GROC BACKUP SELECT -->
</Modal>
